require('./globalPositionFinancialSection.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { mergeOrderAndId } = require('utilities/APIParsingHelper');
// @ components
const GlobalPositionTotalBalance = require('components/globalPosition/globalPositionTotalBalance/globalPositionTotalBalance');
const GlobalPositionCreditCard = require('components/globalPosition/globalPositionCreditCard/globalPositionCreditCard');
const GlobalPositionLoans = require('components/globalPosition/globalPositionLoans/globalPositionLoans');
const GlobalPositionMortgages = require('components/globalPosition/globalPositionMortgages/globalPositionMortgages');
const LinkToPreferences = require('../shared/linkToPreferences');
const WebappRender = require('components/conditionalRender/webappRender')
//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');

const GLOBAL_POSITION_BOXES = require('constants/globalPositionBoxes');

class GlobalPositionFinancialSection extends React.Component {
    buildCreditCardSection() {
        const { immCards, landingBoxes } = this.props;
        const immCreditCards = mergeOrderAndId(
            immCards.getIn(['credit', 'byOrder']),
            immCards.get('byId')
        );
        const noCards = immCards.getIn(['credit', 'byOrder']).isEmpty();
        const hasActiveAndValidCards = immCreditCards.some(
            immCard => immCard.get('active') && immCard.get('status') === 'EN VIGOR'
        );
        const hasVisibleCards = immCreditCards.some(immCard => immCard.get('visibleinPG'));

        let expanded = landingBoxes.includes(GLOBAL_POSITION_BOXES.CREDIT_CARD);

        if (noCards) {
            return;
        }

        if (!hasActiveAndValidCards) {
            return this.buildEmptyState('invalidCards');
        }

        if (!hasVisibleCards) {
            return this.buildEmptyState('allCreditCardsExcluded');
        }

        return (
            <div
                className="global-position-financial-section__subsection"
                id="global-position-credit-card"
            >
                <GlobalPositionCreditCard
                    id={GLOBAL_POSITION_BOXES.CREDIT_CARD}
                    immCards={immCards}
                    expanded={expanded}
                />
            </div>
        );
    }

    buildEmptyState(translationKey) {
        let goToCardsLandingButton;

        if (translationKey === 'invalidCards') {
            goToCardsLandingButton = (
                <OKButton
                    modifier="secondary"
                    onClick={() => {
                        this.props.history.push('/myprofile/cards');
                    }}
                >
                    <FormattedText value="globalPositionFinancialSectionEmptyStates-goToCards" />
                </OKButton>
            );
        }

        return (
            <section className="global-position-financial-section__empty">
                <EmptyState
                    primaryText={formatText(
                        `globalPositionFinancialSectionEmptyStates-${translationKey}`
                    )}
                    button={goToCardsLandingButton}
                    iconType="financiation-banking" />
            </section>
        );
    }

    buildLoansSection() {
        const { immLoans, landingBoxes, easyLoanInfo, immFlagBasedFeature, setWaferIdRequest } = this.props;
        const immLoansByOrder = immLoans.get('loansByOrder');
        const immValidLoans = immLoansByOrder.filter(loanId =>
            immLoans.getIn(['byId', loanId, 'balance', 'amount']) !== 0
        );
        const hasLoans = immValidLoans.size > 0;
        const hasVisibleLoans = immValidLoans.some(loanId =>
            immLoans.getIn(['byId', loanId, 'filters', 'valid'])
        );
        let dataToRender;

        const easyLoanFFStatus = immFlagBasedFeature.get("easy_loan_waffer");
        const showLoans = hasLoans || (easyLoanFFStatus && hasLoans);
        const showEasyLoanInfo = easyLoanInfo && easyLoanFFStatus;
        setWaferIdRequest('');

        if (showLoans || showEasyLoanInfo) {
            if (hasVisibleLoans || easyLoanInfo) {
                const expanded = landingBoxes.includes(GLOBAL_POSITION_BOXES.LOAN);

                dataToRender = (
                    <div className="global-position-financial-section__subsection" id="global-position-loans">
                        <GlobalPositionLoans
                            id={GLOBAL_POSITION_BOXES.LOAN}
                            immLoans={immLoans}
                            easyLoanInfo={easyLoanInfo}
                            expanded={expanded}
                            easyLoanFFStatus={easyLoanFFStatus}
                        />
                    </div>
                );
            } else {
                dataToRender = this.buildEmptyState('allLoansExcluded');
            }
        }

        return dataToRender;
    }

    buildMortgagesSection() {
        const { immLoans, landingBoxes, setWaferIdRequest } = this.props;
        const immMortgagesByOrder = immLoans.get('mortgagesByOrder');
        const immValidMortgages = immMortgagesByOrder.filter(loanId =>
            immLoans.getIn(['byId', loanId, 'balance', 'amount']) !== 0
        );
        const hasMortgages = immValidMortgages.size > 0;
        const hasVisibleMortgages = immValidMortgages.some(loanId =>
            immLoans.getIn(['byId', loanId, 'filters', 'valid'])
        );
        let dataToRender;
        setWaferIdRequest('')
        if (hasMortgages) {
            if (hasVisibleMortgages) {
                const expanded = landingBoxes.includes(GLOBAL_POSITION_BOXES.MORTGAGE);

                dataToRender = (
                    <div className="global-position-financial-section__subsection" id="global-position-mortgages">
                        <GlobalPositionMortgages
                            immLoans={immLoans}
                            id={GLOBAL_POSITION_BOXES.MORTGAGE}
                            expanded={expanded}
                        />
                    </div>
                );
            } else {
                dataToRender = this.buildEmptyState('allMortgagesExcluded');
            }
        }

        return dataToRender;
    }

    getCardsBalance() {
        const { immCards } = this.props;
        let response;

        if (__CONTACT_CENTER__) {
            const immCreditCards = mergeOrderAndId(immCards.getIn(['credit', 'byOrder']), immCards.get('byId'));
            response = immCreditCards.filter(immCard => !!immCard.get('active'))
                .map(immCard => immCard.get('balanceDrawn'));
        } else {
            response = immCards.getIn(['credit', 'balanceDrawnForPG']);
        }

        return response;
    }

    render() {
        const { immLoans } = this.props;
        const globalPositionCreditCard = this.buildCreditCardSection();
        const globalPositionMortgages = this.buildMortgagesSection();
        const globalPositionLoans = this.buildLoansSection();
        const loansBalance = immLoans.get('loansBalanceForPG');
        const mortgagesBalance = immLoans.get('mortgagesBalanceForPG');
        let cardsBalance = this.getCardsBalance();

        // we need to invert the value of cardsBalance to match the negative value of loans, mortgages, etc
        cardsBalance = cardsBalance.updateIn([0, 'amount'], amount => amount * -1);

        const financingAmounts = loansBalance.concat(cardsBalance).concat(mortgagesBalance);

        let financialSection = <CommercialAds path="global" type="wafer" />;
        if (globalPositionCreditCard || globalPositionMortgages || globalPositionLoans) {
            let financialContent = this.buildEmptyState('allInvestmentProductsExcluded');

            financialContent = (
                <section>
                    {globalPositionCreditCard}
                    {globalPositionMortgages}
                    {globalPositionLoans}
                </section>
            );

            financialSection = (
                <div className="global-position-financial-section__section">
                    {financialContent}
                    <GlobalPositionTotalBalance
                        translationKey="myGlobalPosition-totalAmountToFinanciate"
                        immAmounts={financingAmounts}
                        iconClass="default"
                    />
                </div>
            );
        }

        return (
            <section className="global-position-financial-section">
                <div>
                    <h3 className="global-position-financial-section__section-title">
                        <FormattedText value="myGlobalPosition-financing" />
                    </h3>
                    <WebappRender>
                        <div className="global-position-financial-section__link-settings hidden-xs">
                            <span className="global-position-financial-section__link-settings-text">
                                <FormattedText value="myGlobalPosition-settings" />
                            </span>
                            <LinkToPreferences />
                        </div>
                    </WebappRender>
                </div>
                {financialSection}
            </section>
        );
    }
}

GlobalPositionFinancialSection.propTypes = {
    easyLoanInfo: PropTypes.object,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immLoans: PropTypes.object.isRequired,
    landingBoxes: PropTypes.object.isRequired,
    immFlagBasedFeature: PropTypes.object.isRequired,
    setWaferIdRequest: PropTypes.func.isRequired
};

module.exports = withRouter(GlobalPositionFinancialSection);
